import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-4 py-20 overflow-hidden bg-[#0d0d1a]">
      <div
        className="blob w-[500px] h-[500px] top-1/4 left-1/2 -translate-x-1/2"
        style={{ background: 'linear-gradient(135deg, #7c3aed, #a855f7)' }}
      ></div>
      <div
        className="blob w-[300px] h-[300px] bottom-1/4 right-1/4"
        style={{ background: 'linear-gradient(135deg, #a855f7, #7c3aed)', animationDelay: '-8s' }}
      ></div>

      <div className="relative z-10 text-center max-w-xl mx-auto">
        <h1 className="text-7xl md:text-9xl font-extrabold text-white leading-none">404</h1>
        <p className="mt-6 text-xl md:text-2xl font-semibold text-white">ページが見つかりませんでした</p>
        <p className="mt-3 text-[#a0a0b0] text-sm md:text-base">
          お探しのページは移動または削除された可能性があります。
        </p>
        <div className="mt-8 flex justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl h-12 px-8 text-sm font-semibold bg-gradient-to-r from-[#7c3aed] to-[#a855f7] text-white transition-all duration-300 hover:brightness-110 hover:scale-[1.02] hover:shadow-[0_14px_30px_rgba(124,58,237,0.4)]"
          >
            <i className="ri-home-4-line"></i>
            トップへ戻る
          </Link>
        </div>
      </div>
    </section>
  );
}